/**
 * Analytics tracking — pageviews + custom events.
 * Fire-and-forget, never blocks UI, errors swallowed.
 */
import { api } from "@/lib/api";

const SESSION_KEY = "depannidf_session";

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function trackPageview(path, extra = {}) {
  try {
    api.post("/analytics/pageview", {
      path: path || window.location.pathname,
      referrer: document.referrer || null,
      title: document.title || null,
      session_id: getSessionId(),
      ...extra,
    }).catch(() => {});
  } catch {}
}

export function trackEvent(kind, target, extra = {}) {
  try {
    api.post("/analytics/event", {
      kind,
      target: target || null,
      path: window.location.pathname,
      session_id: getSessionId(),
      ...extra,
    }).catch(() => {});
  } catch {}
}
